import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const ShippingAddressIconSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3L1 9H3V15H7V11H9V15H13V9H15L8 3ZM11.5 9V13.5H10.5V9.5H5.5V13.5H4.5V8L8 5L11.5 8V9ZM9 16V18H15V16L18 19L15 22V20H9V22L6 19L9 16ZM23 9H21V15H15V10H19L13.54 5.11L16 3L23 9Z"
      fill="#545454"
    />
  </svg>
);

export const ShippingAddressIcon: FC<Partial<CustomIconComponentProps>> = (
  props
) => <Icon component={ShippingAddressIconSvg} {...props} />;

export default ShippingAddressIcon;

ShippingAddressIcon.displayName = "ShippingAddressIcon";
